import ajaxBlocks from '../util/ajaxBlocks';
import appState from '../util/appState';
import common from '../routes/common';
import moment from 'moment';
import Pikaday from 'pikaday';
import notie from 'notie';

const clients = {
  init() {
    // JavaScript to be fired on the jobs page

    // Init ajaxBlocks
    ajaxBlocks.init();

    Mousetrap.bind('return', e => {
      let focused = document.activeElement;
      if (focused.classList.contains('ajaxblock') && focused.classList.contains('clients')) {
        ajaxBlocks.editClick(e, focused);
      }
    });
  },

  finalize() {
    // JavaScript to be fired on the jobs page, after the init JS
  },
};

export default clients
